<template>
  <v-row class="justify-center" transition="slide-x-transition">
    <v-col cols="12" sm="8" md="6" lg="5" class="d-flex align-stretch pa-1">
      <v-card class="flex-grow-1">
        <v-toolbar color="grey lighten-4" elevation="0" light dense>
          <v-toolbar-title>2ª via da carteirinha</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$router.go(-1)">
            <v-icon>fa-solid fa-reply</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-subtitle
          class="text-left"
        >Para solicitar a segunda via da carteirinha do seu plano preencha o formulário abaixo:</v-card-subtitle>
        <v-card-text>
          <v-form ref="formCardDuplicate" lazy-validation>
            <v-select
              v-model="beneficiary"
              :items="allBeneficiaries"
              item-text="nome"
              label="Selecione o beneficiário"
              @change="fillForm(beneficiary)"
              dense
              v-if="allBeneficiaries && allBeneficiaries.length > 1"
            ></v-select>

            <v-text-field
              v-model="formData.nome"
              :rules="formRules.nameRules"
              label="Nome"
              required
              dense
            ></v-text-field>

            <v-text-field
              v-model="formData.cpf"
              :rules="formRules.cpfRules"
              label="CPF"
              v-mask="'###.###.###-##'"
              required
              dense
            ></v-text-field>
            <v-text-field
              v-model="formData.email"
              :rules="formRules.emailRules"
              label="E-mail"
              required
              dense
            ></v-text-field>
            <v-text-field
              v-model="formData.telefone"
              :rules="formRules.required"
              v-mask="(formData.telefone && formData.telefone.length > 14)? '(##) #####-####' : '(##) ####-#####'"
              label="Telefone"
              required
              dense
            ></v-text-field>
            <v-text-field
              v-model="formData.endereco"
              :rules="formRules.required"
              label="Endereço"
              required
              dense
            ></v-text-field>

            <v-select
              v-model="formData.motivo"
              :items="reasonslist"
              :rules="formRules.required"
              label="Motivo"
              required
              dense
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="grey" class="mr-4" @click="reset">Limpar</v-btn>
          <v-btn :disabled="!valid" outlined color="primary" class="mr-4" @click="sendMail">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
var moment = require("moment");
import { mask } from "vue-the-mask";

export default {
  directives: {
    mask
  },
  data() {
    return {
      allBeneficiaries: [],
      beneficiary: "",
      formData: {
        nome: "",
        cpf: "",
        endereco: "",
        telefone: "",
        email: "",
        motivo: ""
      },
      reasonslist: [
        "Erro no nome",
        "Erro data de nascimento",
        "Erro de carência",
        "Extravio"
      ],
      valid: true
    };
  },
  watch: {
    plans: {
      immediate: true,
      handler(newVal) {
        this.getAllBeneficiaries();
      }
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules,
      plans: state => state.plans.plans
    })
  },
  methods: {
    async getAllBeneficiaries() {
      let list = [];
      await this.$store
        .dispatch("cardDuplicate/getAllBeneficiaries", this.plans)
        .then(resp => (list = resp));
      this.allBeneficiaries = list;
      if (list && list.length == 1) {
        this.fillForm(list[0].nome);
      }
    },
    fillForm(val) {
      if(!val) {
        return
      }
      let { nome, cpf } = this.allBeneficiaries.find(
        e => e.nome == val
      );
      this.formData = {
        nome,
        cpf,
        endereco: "",
        telefone: "",
        email: "",
        motivo: ""
      }
      this.$refs.formCardDuplicate.resetValidation()
    },
    sendMail() {
      let _this = this;
      if (this.$refs.formCardDuplicate.validate()) {
        let opts = {
          token: this.$store.state.tokenSms,
          nome: this.formData.nome,
          cpf: this.formData.cpf,
          endereco: this.formData.endereco,
          telefone: this.formData.telefone,
          email: this.formData.email,
          motivo: this.formData.motivo
        };
        this.$store
          .dispatch("cardDuplicate/sendMail", opts)
          .then(resp => _this.reset());
      }
    },
    reset() {
      this.$refs.formCardDuplicate.reset();
      if (this.allBeneficiaries && this.allBeneficiaries.length == 1) {
        this.fillForm(this.allBeneficiaries[0].nome);
      }
    }
  }
};
</script>

<style>
</style>
